import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';
import { LtoQuestion } from '../../../models/product.types';
import FAQ from './FAQ';

type Props = {
  questions: LtoQuestion[];
};

function FAQs({ questions }: Props): ReactElement {
  const seed = useUIDSeed();

  return (
    <div className="">
      <div className="l-container">
        <br />
        {questions?.length > 0
          && questions.map(({
            question,
            answer,
          }, index) => (
            <FAQ
              key={seed(index)}
              question={question}
              answer={answer}
            />
          ))}
      </div>
    </div>
  );
}

export default FAQs;
